import { EventBus, Events } from "jiffy-store";
import { redirectTo } from "common/utils/browser";

import "./product-details-made-sample-cta.scss";

const $getSampleLinks = () => document.querySelectorAll(".js-made-sample-cta-link");
const $getSampleToggler = () => document.querySelector(".js-made-sample-cta-toggler");
const $getProductPageContainer = () => document.getElementById("product-page-container");

const getProductInfo = () => {
  const $container = $getProductPageContainer();
  if (!$container) return null;

  // Get product ID from data-real-product-id attribute
  const productId = $container.dataset.realProductId;

  // Get product slug from data-product-id attribute
  const productSlug = $container.dataset.productId;

  // Get composition from data-composition-name attribute, URL parameter, or the
  // in-page active color (PIP-3358: ?ac= is absent on the canonical-URL surface)
  const composition =
    $container.dataset.compositionName ||
    new URLSearchParams(window.location.search).get("ac") ||
    document.getElementById("active-color-name")?.value ||
    "White";

  return { productId, productSlug, composition };
};

const initSampleToggler = () => {
  const $sampleToggler = $getSampleToggler();
  if (!$sampleToggler) return;

  // Prevent default link behavior and build dynamic URL
  $sampleToggler.addEventListener("click", e => {
    e.preventDefault();

    const productInfo = getProductInfo();
    const { catalogNumber } = $sampleToggler.dataset;
    if (!productInfo || !catalogNumber) return;
    const url = new URL("/design-lab", window.location.origin);
    url.searchParams.set("catalog_number", catalogNumber);
    url.searchParams.set("ac", productInfo.composition);
    url.searchParams.set("sample", "true");

    redirectTo(url);
  });
};

const updateDataAttributes = color => {
  const $sampleLinks = $getSampleLinks();
  const $container = $getProductPageContainer();

  // Update all sample links
  $sampleLinks.forEach($link => {
    const url = new URL($link.href);
    url.searchParams.set("ac", color);
    // eslint-disable-next-line no-param-reassign
    $link.href = url.pathname + url.search;
  });

  // Update the data-composition-name attribute on the product page container
  if ($container) {
    $container.dataset.compositionName = color;
  }
};

const initChangeColorHandler = () => {
  // Handle color changes from slider
  EventBus.on(Events.PRODUCT_COLOR_SELECTED_FROM_SLIDER, (e, { color }) => {
    updateDataAttributes(color);
  });

  // Handle color changes from modal
  EventBus.on(Events.PRODUCT_COLOR_SELECTED, (e, { color }) => {
    updateDataAttributes(color);
  });
};

export default () => {
  initSampleToggler();
  initChangeColorHandler();
};
